import React from 'react'
import { Area, AreaChart, CartesianGrid, ResponsiveContainer } from 'recharts'
import { ChartTooltip, XAxis, YAxis } from '../../components'
import { useMediaQuery } from '../../hooks'
import { formatGraphData, getAxisDomain } from '../../helpers'
import { GraphComponentProps } from '../../types'

const ViewPerAdChart: React.FC<GraphComponentProps> = ({ data, graphHeight }) => {
  const displayType = useMediaQuery()

  const getMonthFormat = () => {
    switch (displayType) {
      case 'tablet':
        return 'three'
      default:
        return 'one'
    }
  }

  const formattedData = formatGraphData('views', undefined, data, value =>
    Math.round(Number(value))
  )
  const domain = getAxisDomain(formattedData, 'views')

  return (
    <ResponsiveContainer width={'99%'} height={graphHeight}>
      <AreaChart data={formattedData} margin={{ left: -10 }}>
        <defs>
          <linearGradient id="color-vp" x1="0" y1="0" x2="0" y2="1">
            <stop stopColor="#3A63F8" stopOpacity={0.2} />
            <stop offset="1" stopColor="#3A63F8" stopOpacity={0} />
          </linearGradient>
        </defs>
        {XAxis({ monthFormat: getMonthFormat(), chartType: 'line' })}
        {YAxis({ dataKey: 'views', domain })}
        <CartesianGrid stroke="#CED8FD" strokeDasharray="5 5" />
        {ChartTooltip({ cursor: { stroke: '#292E3D', strokeDasharray: '5 5' } })}
        <Area
          type="monotone"
          strokeWidth={2}
          fillOpacity={1}
          activeDot={{ r: 7.5, strokeWidth: 2 }}
          dataKey="views"
          stroke="#3A64F8"
          fill="url(#color-vp)"
        />
      </AreaChart>
    </ResponsiveContainer>
  )
}

export default ViewPerAdChart
